import { Controller } from 'stimulus';
import { getBreakpointValue } from '../tailwindhelpers';
import { useWindowResize } from 'stimulus-use';

export default class extends Controller {
  static targets = ['tab', 'content', 'contentList']; 
  static classes = [ 'active' ];

  connect() {
    useWindowResize(this);

    /*
    * Needs setTimeout to wait for child controller (Toggle),
    * otherwise Toggle cant't catch the event
    */ 
    setTimeout(() => { 
      this.openRandom();
    }, 0);
  }

  windowResize() {
    this.copyContentNodes();
  }

  copyContentNodes() {
    if (window.innerWidth > getBreakpointValue('md')) {
      this.contentTargets.forEach(el => {
        this.contentListTarget.appendChild(el);
      })
    } else { 
      for (let i = 0; i < this.contentTargets.length -1; i++) {
        this.tabTargets[i].appendChild(this.contentTargets[i]);
      }
    }
  }

  change(e) {
    const clickedId = e.currentTarget.dataset.id; 

    this.tabTargets.forEach(el => {
      if (e.currentTarget.dataset.id == el.dataset.id) {
        if (el.dataset.open == 'false') {
          this.openTab(el);
        } else {
          this.closeTab(el);
        }
      } else {
        this.closeTab(el);
      }
    })

    this.contentTargets.forEach(el => {
      if (e.currentTarget.dataset.id == el.dataset.id) {
        if (el.dataset.open == 'false') {
          this.openContent(el);
        } else {
          this.closeContent(el);
        }
      } else {
        this.closeContent(el);
      }
    }) 
  }

  openRandom() { 
    const random = Math.floor(Math.random() * this.tabTargets.length);
    this.openTab(this.tabTargets[random]);
    this.openContent(this.contentTargets[random]);
  }

  openTab(el) {
    if (el) { 
      el.classList.add(this.activeClass);
      el.dataset.open = true;
      el.dispatchEvent(new Event('tab:open'));
    }
  }

  closeTab(el) {
    if (el) { 
      el.classList.remove(this.activeClass);
      el.dataset.open = false;
      el.dispatchEvent(new Event('tab:close'));
    }
  }

  openContent(el) {
    if (el) { 
      el.classList.add(this.activeClass);
      el.dataset.open = true;
    }
  }

  closeContent(el) {
    if (el) { 
      el.classList.remove(this.activeClass);
      el.dataset.open = false;
    }
  }
}
